const chooseSection = $('#choose-section');
const reasonCardsOverflow = chooseSection.find('.choose-section-cards-list-overflow');
const reasonCardsList = chooseSection.find('.choose-section-cards-list')
const reasonCards = chooseSection.find('.reason-card-parent');
const reasonCardsCount = reasonCards.length;
const chooseBtn = chooseSection.find('.button-parent');

const reasonCardsOffset = isDesktop() ? 19.375 : isTablet() ? 32.25 : 79.167;

const reasonCardsAnimation = () => {
  const reasonCardsEasing = CustomEase.create('reasonCardsEasing', '1, 0, 0.2, 1');
  const reasonCardsTL = gsap.timeline({ paused: true });
  reasonCardsTL.add(
    gsap.to(reasonCards, {
      x: 0,
      duration: 1,
      ease: 'reasonCardsEasing',
    })
  );
  return reasonCardsTL;
};

const setPinOffset = () => {
  const choosePinContainer = chooseSection.find('.section-pin-container');
  const choosePinContainerHeight = pxToVh(choosePinContainer.outerHeight());
  const topContentOffset = (100 - choosePinContainerHeight) / 2;
  //gsap.set(choosePinContainer, { top: `${topContentOffset}vh` });
};

const setReasonCards = () => {
  gsap.set(reasonCards, {
    x: (i) => {
      if (isDesktop()) {
        return `${-(i - 1) * reasonCardsOffset}vw`;
      } else {
        return `${-i * reasonCardsOffset}vw`;
      }
    },
    zIndex: (i) => (reasonCardsCount - 1 - i) * 100,
  });
};

const addChooseAnimation = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #081B48 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };

  const chooseTL = gsap.timeline({
    paused: true,
    onComplete: () => {
      gsap.set($('.choose-section-cards-list-overflow'), { overflowX: 'scroll' });
    },
  });

  chooseTL.add(
    animateSectionTopperIn({
      sectionParent: chooseSection,
      gradientConfig: gradientConfig,
    }).play(),
    0
  );

  chooseTL.add(elementInAnimationYWOpacity(reasonCards, '36%', 1, 1, 1).play(), 0.1)
  addBtnAnimation(chooseBtn, 60, true);

  return chooseTL;
};

let chooseTL, reasonCardsTL;
let chooseTrigger, reasonCardsTrigger;

function initChooseAnimations() {
    if(isDesktop()){
      setPinOffset();
      setReasonCards();
      chooseTL = addChooseAnimation();
      reasonCardsTL = reasonCardsAnimation();
      chooseTrigger = ScrollTrigger.create({
        trigger: chooseSection,
        start: 'top top+=120%',
        end: 'top top+=20%',
        once: true,
        onUpdate: (self) => {
          chooseTL.progress(self.progress);
        },
      });
      reasonCardsTrigger = ScrollTrigger.create({
        trigger: chooseSection,
        start: 'top top',
        end: 'bottom bottom',
        onUpdate: (self) => {
          reasonCardsTL.progress(self.progress);
        },
      });
    } else {
      cardsListLenis = new Lenis({ wrapper: reasonCardsOverflow.get(0), autoRaf: true });
    }
}

$(window).on('deviceChange', function () {
  if (chooseTrigger) chooseTrigger.kill();
  if (reasonCardsTrigger) reasonCardsTrigger.kill();
  if (chooseTL) chooseTL.kill();
  if (reasonCardsTL) reasonCardsTL.kill();

  initChooseAnimations();
});

addSectionObserver(chooseSection, initChooseAnimations)